module.exports = function getResource(label, vars = []) {
    let resources = {
        accountInfoTitle: 'Renseignements sur le compte'
    };
    return resources[label];
};
